import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import {
  getCareDirectiveData,
  setCareDirectiveData,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import { useLocation, useParams } from "react-router-dom";
import { FormHeading } from "../../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const GetStarted = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    name: "",
    generalWish: "",
  });

  const validate = Yup.object({
    name: Yup.string().max(50, t("max-50-characters")).nullable(),
    generalWish: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);

    const payload = {
      ...data,
      ...values,
      startedStepStatus: values?.name && values?.generalWish ? 2 : 1,
    };
    const result = await setCareDirectiveData(payload, id);
    if (result?.success) {
      next();
    }
    setButtonDisabled(false);
  };

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getCareDirectiveData(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad?.name || result.payLoad?.generalWish) {
          setInitialValues({
            name: result.payLoad?.name || "",
            generalWish: result.payLoad?.generalWish || "",
          });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <FormHeading variant="h4" color="color.magentaDark1">
              {t("wishes-in-need-of-care")}
            </FormHeading>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate}
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder={t("soi-heading-2")}
                    label={t("input-5")}
                    name="name"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    sx={{ mt: 2 }}
                  />

                  <InputLabel sx={{ mt: 2 }}>{t("cd-gs-wishes")}</InputLabel>
                  <FormHelperText>{t("cd-gs-eg")}</FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={6}
                    variant="outlined"
                    name="generalWish"
                    type="text"
                  />
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default GetStarted;
